if (!customElements.get('custom-media-gallery')) {
  class CustomMediaGallery extends HTMLElement {
    constructor() {
      super();
      this.main = this.querySelector('[data-main]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.thumbsTrack = this.querySelector('[data-thumbs-track]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.prevBtn = this.querySelector('[data-thumb-prev]');
      this.nextBtn = this.querySelector('[data-thumb-next]');

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goToSlide(Number(thumb.dataset.index)));
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollThumbs(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollThumbs(1));

      if (this.main && this.slides.length > 1 && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                const index = this.slides.indexOf(entry.target);
                if (index > -1) this.setActive(index);
              }
            });
          },
          { root: this.main, threshold: [0.6] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      if (this.thumbsTrack) {
        this.thumbsTrack.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
        window.addEventListener('resize', () => this.updateArrowState());
      }

      this.updateArrowState();
      setTimeout(() => this.updateArrowState(), 150);
    }

    goToSlide(index) {
      const slide = this.slides[index];
      if (!slide || !this.main) return;
      this.main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      this.setActive(index);
    }

    setActive(index) {
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      const activeThumb = this.thumbs[index];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
      setTimeout(() => this.updateArrowState(), 200);
    }

    scrollThumbs(direction) {
      if (!this.thumbsTrack) return;
      const thumb = this.thumbs[0];
      const step = thumb ? thumb.getBoundingClientRect().width + 8 : 80;
      this.thumbsTrack.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    updateArrowState() {
      if (!this.thumbsTrack || !this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.thumbsTrack;
      this.prevBtn.disabled = scrollLeft <= 1;
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  }

  customElements.define('custom-media-gallery', CustomMediaGallery);
}
